module.exports = __webpack_public_path__ + "img/45.042d80aa.jpg";